<loader [position]="{ absolute: true }" [active]="!isVinInfo"></loader>
<main class="main wrapper__main report" *ngIf="vinInfo">
  <!-- <embed type="text/html" width="500" height="200" id="setbackgroundInfo" class="report__infobackground"> -->
  <section class="report__topheader">
    <div class="container">
      <div class="row mx-n2">
        <div class="col-12 px-2">
          <div class="report__header py-4 mb-3">
            <div class="report__logo mx-auto">
              <img src="assets/images/logo3.svg" width="200" class="logo" />
            </div>
          </div>
        </div>

        <div class="col-6 px-2">
          <div class="report__showcase_image">
            <img
              src="{{ mainImage ? mainImage : '/assets/images/na.png' }}"
              width="200"
              height="200"
            />
          </div>
        </div>

        <div class="col-6 px-2">
          <div class="report__itemCode mb-3">
            <h4 class="fs fs__md-high font-weight-bold text-center">
              {{ vinInfo['vehicle_item_code'] }}
            </h4>
          </div>
          <div class="report__ratingContainer">
            <div class="report__rating mr-3">
              <h4 class="fs fs__md font-weight-bold my-0">{{ 'calculated_value' | translate }}</h4>
              <div
                class="report__score my-3"
                [class.excellent]="calculatedScore >= 5"
                [class.good]="calculatedScore >= 4.5 && calculatedScore < 5"
                [class.v-fair]="calculatedScore >= 4 && calculatedScore <= 4.5"
                [class.fair]="calculatedScore >= 3.5 && calculatedScore <= 3.999"
                [class.avg]="calculatedScore >= 3 && calculatedScore <= 3.4"
                [class.b-avg]="calculatedScore >= 2.5 && calculatedScore <= 2.999"
                [class.poor]="calculatedScore >= 2 && calculatedScore <= 2.4"
                [class.v-poor]="calculatedScore >= 1.5 && calculatedScore <= 1.999"
                [class.junk]="calculatedScore >= 1 && calculatedScore <= 1.4"
              >
                {{ +calculatedScore > 5 ? '5.0' : (+calculatedScore | number: '0.1-1') }}
              </div>

              <p class="report__ratingTitle my-0">
                <ng-container *ngIf="calculatedScore >= 5">
                  {{ 'grading.excellent' | translate }}
                </ng-container>
                <ng-container *ngIf="calculatedScore >= 4.5 && calculatedScore < 5">
                  {{ 'grading.good' | translate }}
                </ng-container>
                <ng-container *ngIf="calculatedScore >= 4 && calculatedScore <= 4.5">
                  {{ 'grading.v_fair' | translate }}
                </ng-container>
                <ng-container *ngIf="calculatedScore >= 3.5 && calculatedScore <= 3.999">
                  {{ 'grading.fair' | translate }}
                </ng-container>
                <ng-container *ngIf="calculatedScore >= 3 && calculatedScore <= 3.5">
                  {{ 'grading.average' | translate }}
                </ng-container>
                <ng-container *ngIf="calculatedScore >= 2.5 && calculatedScore <= 2.999">
                  {{ 'grading.below_average' | translate }}
                </ng-container>
                <ng-container *ngIf="calculatedScore >= 2 && calculatedScore <= 2.4">
                  {{ 'grading.poor' | translate }}
                </ng-container>
                <ng-container *ngIf="calculatedScore >= 1.5 && calculatedScore <= 1.999">
                  {{ 'grading.v_poor' | translate }}
                </ng-container>
                <ng-container *ngIf="calculatedScore >= 1 && calculatedScore <= 1.5">
                  {{ 'grading.junk' | translate }}
                </ng-container>
              </p>
            </div>

            <div class="report__rating">
              <h4 class="fs fs__md font-weight-bold my-0">{{ 'perceived_value' | translate }}</h4>

              <div
                class="report__score my-3"
                [class.excellent]="PerceivedScore >= 5"
                [class.good]="PerceivedScore >= 4.5 && PerceivedScore !== 5"
                [class.v-fair]="PerceivedScore >= 4 && PerceivedScore <= 4.5"
                [class.fair]="PerceivedScore >= 3.5 && PerceivedScore <= 3.999"
                [class.avg]="PerceivedScore >= 3 && PerceivedScore <= 3.4"
                [class.b-avg]="PerceivedScore >= 2.5 && PerceivedScore <= 2.999"
                [class.poor]="PerceivedScore >= 2 && PerceivedScore <= 2.4"
                [class.v-poor]="PerceivedScore >= 1.5 && PerceivedScore <= 1.999"
                [class.junk]="PerceivedScore >= 1 && PerceivedScore <= 1.4"
              >
                {{ +PerceivedScore ? PerceivedScore : 'N/A' }}
              </div>

              <p class="report__ratingTitle my-0">
                <ng-container *ngIf="PerceivedScore >= 5">
                  {{ 'grading.excellent' | translate }}
                </ng-container>
                <ng-container *ngIf="PerceivedScore >= 4.5 && PerceivedScore !== 5">
                  {{ 'grading.good' | translate }}
                </ng-container>
                <ng-container *ngIf="PerceivedScore >= 4 && PerceivedScore <= 4.5">
                  {{ 'grading.v_fair' | translate }}
                </ng-container>
                <ng-container *ngIf="PerceivedScore >= 3.5 && PerceivedScore <= 3.999">
                  {{ 'grading.fair' | translate }}
                </ng-container>
                <ng-container *ngIf="PerceivedScore >= 3 && PerceivedScore <= 3.5">
                  {{ 'grading.average' | translate }}
                </ng-container>
                <ng-container *ngIf="PerceivedScore >= 2.5 && PerceivedScore <= 2.999">
                  {{ 'grading.below_average' | translate }}
                </ng-container>
                <ng-container *ngIf="PerceivedScore >= 2 && PerceivedScore <= 2.4">
                  {{ 'grading.poor' | translate }}
                </ng-container>
                <ng-container *ngIf="PerceivedScore >= 1.5 && PerceivedScore <= 1.999">
                  {{ 'grading.v_poor' | translate }}
                </ng-container>
                <ng-container *ngIf="PerceivedScore >= 1 && PerceivedScore <= 1.5">
                  {{ 'grading.junk' | translate }}
                </ng-container>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="report__value my-5">
    <div class="container">
      <div class="row mx-n2 my-2">
        <div class="col-4 px-2" [class.no-print]="!marketValueChecked">
          <div class="report__valueItem d-flex justify-content-center align-items-center">
            <div class="form-check checkbox-xl no-print">
              <input
                class="form-check-input m-0 position-static"
                type="checkbox"
                [checked]="marketValueChecked"
                (change)="handleMarketValueCheck($event)"
              />
            </div>
            <div class="mx-5">
              <p class="fs fs__md mb-2">{{ 'market_value' | translate }}</p>
              {{ +ratings['market_value'] ? 'SAR ' + ratings['market_value'] : 'N/A' }}
            </div>
          </div>
        </div>
        <div class="col-4 px-2" [class.no-print]="!purchaseValueChecked">
          <div class="report__valueItem d-flex justify-content-center align-items-center">
            <div class="form-check checkbox-xl no-print">
              <input
                class="form-check-input m-0 position-static"
                type="checkbox"
                [checked]="purchaseValueChecked"
                (change)="handlePurchaseValueCheck($event)"
              />
            </div>
            <div class="mx-5">
              <p class="fs fs__md mb-2">{{ 'purchase_value' | translate }}</p>
              {{ +ratings['purchase_value'] ? 'SAR ' + ratings['purchase_value'] : 'N/A' }}
            </div>
          </div>
        </div>
        <div class="col-4 px-2" [class.no-print]="!totalRepairCostChecked">
          <div class="report__valueItem d-flex justify-content-center align-items-center">
            <div class="form-check checkbox-xl no-print">
              <input
                class="form-check-input m-0 position-static"
                type="checkbox"
                [checked]="totalRepairCostChecked"
                (change)="handleTotalRepairCostCheck($event)"
              />
            </div>
            <div class="mx-5">
              <p class="fs fs__md mb-2">{{ 'total_repair_cost' | translate }}</p>
              {{ +ratings['total_repair_cost'] ? 'SAR ' + ratings['total_repair_cost'] : 'N/A' }}
            </div>
          </div>
        </div>
      </div>

      <div class="row mx-n2">
        <div class="col-4 px-2" [class.no-print]="!marketValueChecked">
          <div class="report__valueItem d-flex justify-content-center align-items-center">
            <div class="form-check checkbox-xl no-print">
              <input
                class="form-check-input m-0 position-static"
                type="checkbox"
                [checked]="showNotApplicableValues"
                (change)="handleShowNotApplicableValuesCheckbox($event)"
              />
            </div>
            <div class="mx-5">
              <p class="fs fs__md mb-2">Show N/A values</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="report__specification mb-5">
    <div class="container">
      <div class="report__heading mb-4 mt-4">
        <h2 class="fs fs__md-high">{{ 'specs' | translate }}</h2>
      </div>

      <div class="row mx-n2">
        <div
          class="col-sm-6 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['model_year_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.model_yr' | translate }}:</span>
            <span>
              {{ showTextValue(vinInfo['model_year_id']?.['value']) }}
            </span>
          </p>
        </div>
        <div
          class="col-sm-6 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['make_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.make' | translate }}:</span>
            {{ showTextValue(vinInfo['make_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['model_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.model' | translate }}:</span>
            <span>
              {{ showTextValue(vinInfo['model_id']?.['value']) }}
            </span>
          </p>
        </div>
        <div
          class="col-sm-6 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['body_type_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.body_type' | translate }}:</span>
            <span>
              {{ showTextValue(vinInfo['body_type_id']?.['value']) }}
            </span>
          </p>
        </div>
        <div
          class="col-sm-6 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['drive_type_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.drive_type' | translate }}:</span>
            <span>
              {{ showTextValue(vinInfo['drive_type_id']?.['value']) }}
            </span>
          </p>
        </div>
        <div
          class="col-sm-6 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues &&
            showTextValue(vinInfo['engine_type_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.engine_type' | translate }}:</span>
            <span>
              {{ showTextValue(vinInfo['engine_type_id']?.['value']) }}
            </span>
          </p>
        </div>
        <div
          class="col-sm-6 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues &&
            showTextValue(vinInfo['transmission_type_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.transmission_type' | translate }}:</span
            >
            <span>
              {{ showTextValue(vinInfo['transmission_type_id']?.['value']) }}
            </span>
          </p>
        </div>
        <div
          class="col-sm-6 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['mileage_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.mileage' | translate }}:</span>
            <span>
              {{ showTextValue(vinInfo['mileage_id']?.['value']) }}
            </span>
          </p>
        </div>
        <div
          class="col-sm-6 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues &&
            showTextValue(vinInfo?.['exterior_color_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.exterior_colour' | translate }}:</span
            >
            <span>
              {{ showTextValue(vinInfo?.['exterior_color_id']?.['value']) }}
            </span>
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues &&
            showTextValue(vinInfo?.['estimara_expiry_date']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.estimara_expiry_date' | translate }}:</span
            >
            <span>
              {{ showTextValue(vinInfo?.['estimara_expiry_date']?.['value']) }}
            </span>
          </p>
        </div>
        <div
          class="col-sm-6 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['trim_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.trim_/_type' | translate }}:</span>
            <span>
              {{ showTextValue(vinInfo['trim_id']?.['value']) }}
            </span>
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="report__information mb-5">
    <div class="container">
      <div class="report__heading mb-4">
        <h2 class="fs fs__md-high text-capitalize">{{ 'nav_information' | translate }}</h2>
      </div>

      <div class="row mx-n2">
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['vin_number']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.vin_number' | translate }}:</span>
            <span>
              {{ showTextValue(vinInfo['vin_number']?.['value']) }}
            </span>
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['plate_number']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.plate_number' | translate }}:</span>
            {{ showTextValue(vinInfo['plate_number']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues &&
            showTextValue(vinInfo['assessment_type_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.assessment_type' | translate }}:</span
            >
            {{ showTextValue(vinInfo['assessment_type_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues &&
            showTextValue(vinInfo['vehicle_condition_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.condition' | translate }}:</span>
            {{ showTextValue(vinInfo['vehicle_condition_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues &&
            showTextValue(vinInfo['engine_type_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.engine_type' | translate }}:</span>
            {{ showTextValue(vinInfo['engine_type_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['vendor_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.vendor' | translate }}:</span>
            {{ showTextValue(vinInfo['vendor_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues &&
            showTextValue(vinInfo['vehicle_origin_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.origin' | translate }}:</span>
            {{ showTextValue(vinInfo['vehicle_origin_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['fuel_type_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.fuel_type' | translate }}:</span>
            {{ showTextValue(vinInfo['fuel_type_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['estimara_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.estimara' | translate }}:</span>
            {{ showTextValue(vinInfo['estimara_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['make_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.make' | translate }}:</span>
            {{ showTextValue(vinInfo['make_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['engine_cc_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.cc' | translate }}:</span>
            {{ showTextValue(vinInfo['engine_cc_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues &&
            showTextValue(vinInfo['service_maintainance']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.service_and_maintenance_status' | translate }}:</span
            >
            {{ showTextValue(vinInfo['service_maintainance']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['model_year_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.model_yr' | translate }}:</span>
            {{ showTextValue(vinInfo['model_year_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['cyllinder_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.cylinders' | translate }}:</span>
            {{ showTextValue(vinInfo['cyllinder_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['odo']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.odo' | translate }}:</span>
            {{ showTextValue(vinInfo['odo']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['model_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.model' | translate }}:</span>
            {{ showTextValue(vinInfo['model_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues &&
            showTextValue(vinInfo['transmission_type_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.transmission_type' | translate }}:</span
            >
            {{ showTextValue(vinInfo['transmission_type_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['max_speed']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.max_speed' | translate }}:</span>
            {{ showTextValue(vinInfo['max_speed']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['trim_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.trim_/_type' | translate }}:</span>
            {{ showTextValue(vinInfo['trim_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['gear_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.gear' | translate }}:</span>
            {{ showTextValue(vinInfo['gear_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['mileage_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.mileage' | translate }}:</span>
            {{ showTextValue(vinInfo['mileage_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues &&
            showTextValue(vinInfo['vehicle_type_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.vehicle_type' | translate }}:</span>
            {{ showTextValue(vinInfo['vehicle_type_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['seat_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.seats' | translate }}:</span>
            {{ showTextValue(vinInfo['seat_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues &&
            showTextValue(vinInfo['exterior_color_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.exterior_colour' | translate }}:</span
            >
            {{ showTextValue(vinInfo['exterior_color_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['body_type_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.body_type' | translate }}:</span>
            {{ showTextValue(vinInfo['body_type_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['uphoistery_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.upholstery' | translate }}:</span>
            {{ showTextValue(vinInfo['uphoistery_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues &&
            showTextValue(vinInfo['interior_color_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.interior_colour' | translate }}:</span
            >
            {{ showTextValue(vinInfo['interior_color_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['drive_type_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.drive_type' | translate }}:</span>
            {{ showTextValue(vinInfo['drive_type_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['door_type_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.doors' | translate }}:</span>
            {{ showTextValue(vinInfo['door_type_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['cod_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.cod' | translate }}:</span>
            {{ showTextValue(vinInfo['cod_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['wheel_base_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.wheel_base' | translate }}:</span>
            {{ showTextValue(vinInfo['wheel_base_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['ownership_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.ownership' | translate }}:</span>
            {{ showTextValue(vinInfo['ownership_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues &&
            showTextValue(vinInfo['utility_type_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.utility_type' | translate }}:</span>
            {{ showTextValue(vinInfo['utility_type_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['mortage_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.finance_status' | translate }}:</span
            >
            {{ showTextValue(vinInfo['mortage_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['warranty_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.warranty' | translate }}:</span>
            {{ showTextValue(vinInfo['warranty_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues &&
            showTextValue(vinInfo['warranty_expiry_date']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.warranty_expiry_date' | translate }}:</span
            >
            {{ showTextValue(vinInfo['warranty_expiry_date']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues &&
            showTextValue(vinInfo['last_service_date']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.last_service_date' | translate }}:</span
            >
            {{ showTextValue(vinInfo['last_service_date']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues &&
            showTextValue(vinInfo['last_service_km']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.last_service_kilometers' | translate }}:</span
            >
            {{ showTextValue(vinInfo['last_service_km']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['power_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.hp' | translate }}:</span>
            {{ showTextValue(vinInfo['power_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues && showTextValue(vinInfo['torque_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.torque' | translate }}:</span>
            {{ showTextValue(vinInfo['torque_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues &&
            showTextValue(vinInfo['acceleration_id']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.acceleration' | translate }}:</span>
            {{ showTextValue(vinInfo['acceleration_id']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues &&
            showTextValue(vinInfo['estimara_expiry_date']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.estimara_expiry_date' | translate }}:</span
            >
            {{ showTextValue(vinInfo['estimara_expiry_date']?.['value']) }}
          </p>
        </div>
        <div
          class="col-sm-6 col-md-4 mb-3 px-2"
          [class.no-print]="
            !showNotApplicableValues &&
            showTextValue(vinInfo['mvpi_expiry_date']?.['value']) === 'N/A'
          "
        >
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.mvpi_expiry_date' | translate }}:</span
            >
            {{ showTextValue(vinInfo['mvpi_expiry_date']?.['value']) }}
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="report__option mb-5">
    <div class="container">
      <div class="report__heading mb-4">
        <h2 class="fs fs__md-high text-capitalize">{{ 'nav_options' | translate }}</h2>
      </div>

      <div class="row mx-n2">
        <div class="col-sm-4 col-md-3 mb-3 px-2" *ngFor="let option of options">
          <div class="report__details">
            <span class="font-weight-bold mr-2">
              <ng-container *ngIf="lang == 'en'">
                {{ option['title'] }}
              </ng-container>
              <ng-container *ngIf="lang == 'ar'">
                {{ option['arabic_title'] }}
              </ng-container>
            </span>
            <ul class="my-0" *ngIf="dataTypeChecker(option['data']) === 'object'">
              <li *ngFor="let item of option['data']">
                <ng-container *ngIf="lang == 'en'">
                  {{ item['title'] }}
                </ng-container>
                <ng-container *ngIf="lang == 'ar'">
                  {{ item['arabic_title'] }}
                </ng-container>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="report__flags mb-5">
    <div class="container">
      <div class="report__heading mb-4">
        <h2 class="fs fs__md-high text-capitalize">{{ 'nav_flags' | translate }}</h2>
      </div>

      <div class="row mx-n2">
        <div class="col-sm-4 col-md-3 mb-3 px-2" *ngFor="let flag of flags">
          <p class="report__details font-weight-bold text-capitalize my-0">{{ flag }}</p>
        </div>
      </div>
    </div>
  </section>

  <section class="report__ratingsection mb-5">
    <div class="container">
      <div class="report__heading mb-4">
        <h2 class="fs fs__md-high text-capitalize">{{ 'nav_rating' | translate }}</h2>
      </div>
    </div>

    <div class="report__exterior mb-5">
      <div class="container">
        <div class="report__heading2 mb-4">
          <h3 class="fs fs__md font-weight-bold my-0">{{ 'nav_exterior' | translate }}</h3>
        </div>
        <div class="exterior untouchable mb-5">
          <ng-container *ngIf="main.length">
            <app-sedan
              [data]="main"
              *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['sedan']"
            ></app-sedan>
            <app-microbus
              [data]="main"
              *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['bus']"
            ></app-microbus>
            <app-truck-single-cabin
              [data]="main"
              *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['truckSingle']"
            ></app-truck-single-cabin>
            <app-truck-double-cabin
              [data]="main"
              *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['truckDouble']"
            ></app-truck-double-cabin>
            <app-suv
              [data]="main"
              *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['suv']"
            ></app-suv>
            <app-cargo-van
              [data]="main"
              *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['cargo']"
            ></app-cargo-van>
          </ng-container>

          <loader [position]="{ absolute: true }" [active]="loaded"></loader>
        </div>

        <div class="pagebreak"></div>

        <div class="report__info">
          <div class="row mx-n2">
            <ng-container *ngFor="let item of ratings['exterior']">
              <div class="col-3 px-2">
                <figure class="infoCard shadow-sm">
                  <div class="infoCard__header">
                    <h3 class="fs fs__md font-weight-bold">
                      <ng-container *ngIf="lang === 'en'">
                        {{ item.parent_part }}
                      </ng-container>
                      <ng-container *ngIf="lang === 'ar'">
                        {{ item.arabic_parent_part }}
                      </ng-container>
                    </h3>
                  </div>
                  <div class="infoCard__images" *ngIf="item.vpcs_old_image || item.vpcs_new_image">
                    <ng-container *ngIf="item.vpcs_old_image && item.vpcs_old_image.length">
                      <h6 class="fs fs__sm mb-1">{{ 'condition_modal.before' | translate }}</h6>

                      <div class="infoCard__before">
                        <ng-container *ngFor="let img of item.vpcs_old_image; index as i">
                          <div class="infoCard__thumb" [class.mr-2]="i === 0" *ngIf="img[i + 1]">
                            <img src="{{ item.image_url + img[i + 1] }}" width="155" height="100" />
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="item.vpcs_new_image && item.vpcs_new_image.length">
                      <h6 class="fs fs__sm mb-1">{{ 'condition_modal.after' | translate }}</h6>
                      <div class="infoCard__after mt-3">
                        <ng-container *ngFor="let img of item.vpcs_new_image; index as i">
                          <div class="infoCard__thumb" [class.mr-2]="i === 0" *ngIf="img[i + 1]">
                            <img src="{{ item.image_url + img[i + 1] }}" width="155" height="100" />
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                  <figcaption class="infoCard__caption">
                    <p
                      class="fs fs__sm mt-0 mb-2"
                      [class.no-print]="!showNotApplicableValues && item.vpcs_conditions === null"
                    >
                      <strong>{{ 'condition_modal.condition' | translate }}:</strong>
                      <ng-container
                        *ngIf="item.vpcs_conditions === null || item.vpcs_conditions.length === 0"
                      >
                        N/A
                      </ng-container>
                      <ng-container *ngFor="let condition of item.vpcs_conditions; index as i">
                        <span *ngIf="lang === 'en'">
                          {{ condition?.['parts_condition_name'] }}
                        </span>
                        <span *ngIf="lang === 'ar'">
                          {{ condition?.['parts_condition_name_arabic'] }}
                        </span>
                        <span *ngIf="i < item.vpcs_conditions.length - 1">,</span>
                      </ng-container>
                    </p>

                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.severity' | translate }}: </strong>
                      <ng-container *ngIf="item.vpcs_severity === '1'"
                        >Part change • 1</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '2'"
                        >Major Repair • 2</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '3'"
                        >Moderate Repair • 3</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '4'"
                        >Minor Repair • 4</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '5'">Good part • 5</ng-container>
                      <ng-container *ngIf="!item.vpcs_severity">N/A</ng-container>
                    </p>

                    <p
                      class="fs fs__sm mb-2"
                      [class.no-print]="!showNotApplicableValues && !isValidCost(item.labour_cost)"
                    >
                      <strong>{{ 'condition_modal.labour_cost' | translate }}:</strong>
                      {{ isValidCost(item.labour_cost) ? 'SAR ' + item.labour_cost : 'N/A' }}
                    </p>
                    <p
                      class="fs fs__sm mb-2 uiui9"
                      [class.no-print]="!showNotApplicableValues && !isValidCost(item.part_cost)"
                    >
                      <strong class="MKM">{{ 'condition_modal.parts_cost' | translate }}:</strong>
                      {{ isValidCost(item.part_cost) ? 'SAR ' + item.part_cost : 'N/A' }}
                    </p>
                    <p
                      class="fs fs__sm mb-2"
                      [class.no-print]="!showNotApplicableValues && !isValidCost(item.repair_cost)"
                    >
                      <strong>{{ 'condition_modal.cost_of_repair' | translate }}:</strong>
                      {{ isValidCost(item.repair_cost) ? 'SAR ' + item.repair_cost : 'N/A' }}
                    </p>

                    <p
                      class="fs fs__sm"
                      [class.no-print]="
                        !showNotApplicableValues &&
                        showRatingConditionValue(item.description) === 'N/A'
                      "
                    >
                      <strong>{{ 'condition_modal.description' | translate }}:</strong>
                      <!-- {{ item.description || 'N/A' }} -->
                      {{ showRatingConditionValue(item.description) }}
                    </p>
                  </figcaption>
                </figure>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="pagebreak"></div>

    <div class="report__interior mb-5">
      <div class="container">
        <div class="report__heading2 mb-4">
          <h3 class="fs fs__md font-weight-bold my-0">{{ 'nav_interior' | translate }}</h3>
        </div>

        <div class="interior untouchable mb-5">
          <app-interior></app-interior>
        </div>

        <div class="pagebreak"></div>

        <div class="report__info">
          <div class="row mx-n2">
            <ng-container *ngFor="let item of ratings['interior']">
              <div class="col-3 px-2">
                <figure class="infoCard shadow-sm">
                  <div class="infoCard__header">
                    <h3 class="fs fs__md font-weight-bold">
                      <ng-container *ngIf="lang === 'en'">
                        {{ item.parent_part }}
                      </ng-container>
                      <ng-container *ngIf="lang === 'ar'">
                        {{ item.arabic_parent_part }}
                      </ng-container>
                    </h3>
                  </div>
                  <div class="infoCard__images" *ngIf="item.vpcs_old_image || item.vpcs_new_image">
                    <ng-container *ngIf="item.vpcs_old_image && item.vpcs_old_image.length">
                      <h6 class="fs fs__sm mb-1">{{ 'condition_modal.before' | translate }}</h6>
                      <div class="infoCard__before">
                        <ng-container *ngFor="let img of item.vpcs_old_image; index as i">
                          <div class="infoCard__thumb" [class.mr-2]="i === 0" *ngIf="img[i + 1]">
                            <img src="{{ item.image_url + img[i + 1] }}" width="155" height="100" />
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="item.vpcs_new_image && item.vpcs_new_image.length">
                      <h6 class="fs fs__sm mb-1">{{ 'condition_modal.after' | translate }}</h6>
                      <div class="infoCard__after mt-3">
                        <ng-container *ngFor="let img of item.vpcs_new_image; index as i">
                          <div class="infoCard__thumb" [class.mr-2]="i === 0" *ngIf="img[i + 1]">
                            <img src="{{ item.image_url + img[i + 1] }}" width="155" height="100" />
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                  <figcaption class="infoCard__caption">
                    <p
                      class="fs fs__sm mt-0 mb-2"
                      [class.no-print]="!showNotApplicableValues && item.vpcs_conditions === null"
                    >
                      <strong>{{ 'condition_modal.condition' | translate }}:</strong>
                      <ng-container
                        *ngIf="item.vpcs_conditions === null || item.vpcs_conditions.length === 0"
                      >
                        N/A
                      </ng-container>
                      <ng-container *ngFor="let condition of item.vpcs_conditions; index as i">
                        <span *ngIf="lang === 'en'">
                          {{ condition?.['parts_condition_name'] }}
                        </span>
                        <span *ngIf="lang === 'ar'">
                          {{ condition?.['parts_condition_name_arabic'] }}
                        </span>
                        <span *ngIf="i < item.vpcs_conditions.length - 1">,</span>
                      </ng-container>
                    </p>

                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.severity' | translate }}: </strong>
                      <ng-container *ngIf="item.vpcs_severity === '1'"
                        >Part change • 1</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '2'"
                        >Major Repair • 2</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '3'"
                        >Moderate Repair • 3</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '4'"
                        >Minor Repair • 4</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '5'">Good part • 5</ng-container>
                      <ng-container *ngIf="!item.vpcs_severity">N/A</ng-container>
                    </p>

                    <p
                      class="fs fs__sm mb-2"
                      [class.no-print]="!showNotApplicableValues && !isValidCost(item.labour_cost)"
                    >
                      <strong>{{ 'condition_modal.labour_cost' | translate }}:</strong>
                      {{ isValidCost(item.labour_cost) ? 'SAR ' + item.labour_cost : 'N/A' }}
                    </p>
                    <p
                      class="fs fs__sm mb-2 uiui9"
                      [class.no-print]="!showNotApplicableValues && !isValidCost(item.part_cost)"
                    >
                      <strong class="MKM">{{ 'condition_modal.parts_cost' | translate }}:</strong>
                      {{ isValidCost(item.part_cost) ? 'SAR ' + item.part_cost : 'N/A' }}
                    </p>
                    <p
                      class="fs fs__sm mb-2"
                      [class.no-print]="!showNotApplicableValues && !isValidCost(item.repair_cost)"
                    >
                      <strong>{{ 'condition_modal.cost_of_repair' | translate }}:</strong>
                      {{ isValidCost(item.repair_cost) ? 'SAR ' + item.repair_cost : 'N/A' }}
                    </p>

                    <p
                      class="fs fs__sm"
                      [class.no-print]="
                        !showNotApplicableValues &&
                        showRatingConditionValue(item.description) === 'N/A'
                      "
                    >
                      <strong>{{ 'condition_modal.description' | translate }}:</strong>
                      <!-- {{ item.description || 'N/A' }} -->
                      {{ showRatingConditionValue(item.description) }}
                    </p>
                  </figcaption>
                </figure>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="pagebreak"></div>

    <div class="report__mechanics mb-5">
      <div class="container">
        <div class="report__heading2 mb-4">
          <h3 class="fs fs__md font-weight-bold my-0">{{ 'nav_mechanics' | translate }}</h3>
        </div>

        <div class="mechanics untouchable mb-5">
          <app-mechanics></app-mechanics>
        </div>

        <div class="pagebreak"></div>

        <div class="report__info">
          <div class="row mx-n2">
            <ng-container *ngFor="let item of ratings['mechanics']">
              <div class="col-3 px-2">
                <figure class="infoCard shadow-sm">
                  <div class="infoCard__header">
                    <h3 class="fs fs__md font-weight-bold">
                      <ng-container *ngIf="lang === 'en'">
                        {{ item.parent_part }}
                      </ng-container>
                      <ng-container *ngIf="lang === 'ar'">
                        {{ item.arabic_parent_part }}
                      </ng-container>
                    </h3>
                  </div>
                  <div class="infoCard__images" *ngIf="item.vpcs_old_image || item.vpcs_new_image">
                    <ng-container *ngIf="item.vpcs_old_image && item.vpcs_old_image.length">
                      <h6 class="fs fs__sm mb-1">{{ 'condition_modal.before' | translate }}</h6>
                      <div class="infoCard__before">
                        <ng-container *ngFor="let img of item.vpcs_old_image; index as i">
                          <div class="infoCard__thumb" [class.mr-2]="i === 0" *ngIf="img[i + 1]">
                            <img src="{{ item.image_url + img[i + 1] }}" width="155" height="100" />
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="item.vpcs_new_image && item.vpcs_new_image.length">
                      <h6 class="fs fs__sm mb-1">{{ 'condition_modal.after' | translate }}</h6>
                      <div class="infoCard__after mt-3">
                        <ng-container *ngFor="let img of item.vpcs_new_image; index as i">
                          <div class="infoCard__thumb" [class.mr-2]="i === 0" *ngIf="img[i + 1]">
                            <img src="{{ item.image_url + img[i + 1] }}" width="155" height="100" />
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                  <figcaption class="infoCard__caption">
                    <p
                      class="fs fs__sm mt-0 mb-2"
                      [class.no-print]="!showNotApplicableValues && item.vpcs_conditions === null"
                    >
                      <strong>{{ 'condition_modal.condition' | translate }}:</strong>
                      <ng-container
                        *ngIf="item.vpcs_conditions === null || item.vpcs_conditions.length === 0"
                      >
                        N/A
                      </ng-container>
                      <ng-container *ngFor="let condition of item.vpcs_conditions; index as i">
                        <span *ngIf="lang === 'en'">
                          {{ condition?.['parts_condition_name'] }}
                        </span>
                        <span *ngIf="lang === 'ar'">
                          {{ condition?.['parts_condition_name_arabic'] }}
                        </span>
                        <span *ngIf="i < item.vpcs_conditions.length - 1">,</span>
                      </ng-container>
                    </p>

                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.severity' | translate }}: </strong>
                      <ng-container *ngIf="item.vpcs_severity === '1'"
                        >Part change • 1</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '2'"
                        >Major Repair • 2</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '3'"
                        >Moderate Repair • 3</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '4'"
                        >Minor Repair • 4</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '5'">Good part • 5</ng-container>
                      <ng-container *ngIf="!item.vpcs_severity">N/A</ng-container>
                    </p>

                    <p
                      class="fs fs__sm mb-2"
                      [class.no-print]="!showNotApplicableValues && !isValidCost(item.labour_cost)"
                    >
                      <strong>{{ 'condition_modal.labour_cost' | translate }}:</strong>
                      {{ isValidCost(item.labour_cost) ? 'SAR ' + item.labour_cost : 'N/A' }}
                    </p>
                    <p
                      class="fs fs__sm mb-2 uiui9"
                      [class.no-print]="!showNotApplicableValues && !isValidCost(item.part_cost)"
                    >
                      <strong class="MKM">{{ 'condition_modal.parts_cost' | translate }}:</strong>
                      {{ isValidCost(item.part_cost) ? 'SAR ' + item.part_cost : 'N/A' }}
                    </p>
                    <p
                      class="fs fs__sm mb-2"
                      [class.no-print]="!showNotApplicableValues && !isValidCost(item.repair_cost)"
                    >
                      <strong>{{ 'condition_modal.cost_of_repair' | translate }}:</strong>
                      {{ isValidCost(item.repair_cost) ? 'SAR ' + item.repair_cost : 'N/A' }}
                    </p>

                    <p
                      class="fs fs__sm"
                      [class.no-print]="
                        !showNotApplicableValues &&
                        showRatingConditionValue(item.description) === 'N/A'
                      "
                    >
                      <strong>{{ 'condition_modal.description' | translate }}:</strong>
                      <!-- {{ item.description || 'N/A' }} -->
                      {{ showRatingConditionValue(item.description) }}
                    </p>
                  </figcaption>
                </figure>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="pagebreak"></div>

    <div class="report__frame mb-5">
      <div class="container">
        <div class="report__heading2 mb-4">
          <h3 class="fs fs__md font-weight-bold my-0">{{ 'nav_frame' | translate }}</h3>
        </div>

        <div class="frame untouchable mb-5">
          <app-frame></app-frame>
        </div>

        <div class="pagebreak"></div>

        <div class="report__info">
          <div class="row mx-n2">
            <ng-container *ngFor="let item of ratings['frame']">
              <div class="col-3 px-2">
                <figure class="infoCard shadow-sm">
                  <div class="infoCard__header">
                    <h3 class="fs fs__md font-weight-bold">
                      <ng-container *ngIf="lang === 'en'">
                        {{ item.parent_part }}
                      </ng-container>
                      <ng-container *ngIf="lang === 'ar'">
                        {{ item.arabic_parent_part }}
                      </ng-container>
                    </h3>
                  </div>
                  <div class="infoCard__images" *ngIf="item.vpcs_old_image || item.vpcs_new_image">
                    <ng-container *ngIf="item.vpcs_old_image && item.vpcs_old_image.length">
                      <h6 class="fs fs__sm mb-1">{{ 'condition_modal.before' | translate }}</h6>
                      <div class="infoCard__before">
                        <ng-container *ngFor="let img of item.vpcs_old_image; index as i">
                          <div class="infoCard__thumb" [class.mr-2]="i === 0" *ngIf="img[i + 1]">
                            <img src="{{ item.image_url + img[i + 1] }}" width="155" height="100" />
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="item.vpcs_new_image && item.vpcs_new_image.length">
                      <h6 class="fs fs__sm mb-1">{{ 'condition_modal.after' | translate }}</h6>
                      <div class="infoCard__after mt-3">
                        <ng-container *ngFor="let img of item.vpcs_new_image; index as i">
                          <div class="infoCard__thumb" [class.mr-2]="i === 0" *ngIf="img[i + 1]">
                            <img src="{{ item.image_url + img[i + 1] }}" width="155" height="100" />
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                  <figcaption class="infoCard__caption">
                    <p
                      class="fs fs__sm mt-0 mb-2"
                      [class.no-print]="!showNotApplicableValues && item.vpcs_conditions === null"
                    >
                      <strong>{{ 'condition_modal.condition' | translate }}:</strong>
                      <ng-container
                        *ngIf="item.vpcs_conditions === null || item.vpcs_conditions.length === 0"
                      >
                        N/A
                      </ng-container>
                      <ng-container *ngFor="let condition of item.vpcs_conditions; index as i">
                        <span *ngIf="lang === 'en'">
                          {{ condition?.['parts_condition_name'] }}
                        </span>
                        <span *ngIf="lang === 'ar'">
                          {{ condition?.['parts_condition_name_arabic'] }}
                        </span>
                        <span *ngIf="i < item.vpcs_conditions.length - 1">,</span>
                      </ng-container>
                    </p>

                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.severity' | translate }}: </strong>
                      <ng-container *ngIf="item.vpcs_severity === '1'"
                        >Part change • 1</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '2'"
                        >Major Repair • 2</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '3'"
                        >Moderate Repair • 3</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '4'"
                        >Minor Repair • 4</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '5'">Good part • 5</ng-container>
                      <ng-container *ngIf="!item.vpcs_severity">N/A</ng-container>
                    </p>

                    <p
                      class="fs fs__sm mb-2"
                      [class.no-print]="!showNotApplicableValues && !isValidCost(item.labour_cost)"
                    >
                      <strong>{{ 'condition_modal.labour_cost' | translate }}:</strong>
                      {{ isValidCost(item.labour_cost) ? 'SAR ' + item.labour_cost : 'N/A' }}
                    </p>
                    <p
                      class="fs fs__sm mb-2 uiui9"
                      [class.no-print]="!showNotApplicableValues && !isValidCost(item.part_cost)"
                    >
                      <strong class="MKM">{{ 'condition_modal.parts_cost' | translate }}:</strong>
                      {{ isValidCost(item.part_cost) ? 'SAR ' + item.part_cost : 'N/A' }}
                    </p>
                    <p
                      class="fs fs__sm mb-2"
                      [class.no-print]="!showNotApplicableValues && !isValidCost(item.repair_cost)"
                    >
                      <strong>{{ 'condition_modal.cost_of_repair' | translate }}:</strong>
                      {{ isValidCost(item.repair_cost) ? 'SAR ' + item.repair_cost : 'N/A' }}
                    </p>

                    <p
                      class="fs fs__sm"
                      [class.no-print]="
                        !showNotApplicableValues &&
                        showRatingConditionValue(item.description) === 'N/A'
                      "
                    >
                      <strong>{{ 'condition_modal.description' | translate }}:</strong>
                      <!-- {{ item.description || 'N/A' }} -->
                      {{ showRatingConditionValue(item.description) }}
                    </p>
                  </figcaption>
                </figure>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="pagebreak"></div>

    <div class="report__major-options mb-5">
      <div class="container">
        <div class="report__heading2 mb-4">
          <h3 class="fs fs__md font-weight-bold my-0">{{ 'nav_major_options' | translate }}</h3>
        </div>

        <div class="major-options untouchable mb-5">
          <app-major-options></app-major-options>
        </div>

        <div class="pagebreak"></div>

        <div class="report__info">
          <div class="row mx-n2">
            <ng-container *ngFor="let item of ratings['major_options']">
              <div class="col-3 px-2">
                <figure class="infoCard shadow-sm">
                  <div class="infoCard__header">
                    <h3 class="fs fs__md font-weight-bold">
                      <ng-container *ngIf="lang === 'en'">
                        {{ item.parent_part }}
                      </ng-container>
                      <ng-container *ngIf="lang === 'ar'">
                        {{ item.arabic_parent_part }}
                      </ng-container>
                    </h3>
                  </div>
                  <div class="infoCard__images" *ngIf="item.vpcs_old_image || item.vpcs_new_image">
                    <ng-container *ngIf="item.vpcs_old_image && item.vpcs_old_image.length">
                      <h6 class="fs fs__sm mb-1">{{ 'condition_modal.before' | translate }}</h6>
                      <div class="infoCard__before">
                        <ng-container *ngFor="let img of item.vpcs_old_image; index as i">
                          <div class="infoCard__thumb" *ngIf="img[i + 1]">
                            <img src="{{ item.image_url + img[i + 1] }}" width="155" height="100" />
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="item.vpcs_new_image && item.vpcs_new_image.length">
                      <h6 class="fs fs__sm mb-1">{{ 'condition_modal.after' | translate }}</h6>
                      <div class="infoCard__after mt-3">
                        <ng-container *ngFor="let img of item.vpcs_new_image; index as i">
                          <div class="infoCard__thumb" *ngIf="img[i + 1]">
                            <img src="{{ item.image_url + img[i + 1] }}" width="155" height="100" />
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                  <figcaption class="infoCard__caption">
                    <p
                      class="fs fs__sm mt-0 mb-2"
                      [class.no-print]="!showNotApplicableValues && item.vpcs_conditions === null"
                    >
                      <strong>{{ 'condition_modal.condition' | translate }}:</strong>
                      <ng-container
                        *ngIf="item.vpcs_conditions === null || item.vpcs_conditions.length === 0"
                      >
                        N/A
                      </ng-container>
                      <ng-container *ngFor="let condition of item.vpcs_conditions; index as i">
                        <span *ngIf="lang === 'en'">
                          {{ condition?.['parts_condition_name'] }}
                        </span>
                        <span *ngIf="lang === 'ar'">
                          {{ condition?.['parts_condition_name_arabic'] }}
                        </span>
                        <span *ngIf="i < item.vpcs_conditions.length - 1">,</span>
                      </ng-container>
                    </p>

                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.severity' | translate }}: </strong>
                      <ng-container *ngIf="item.vpcs_severity === '1'"
                        >Part change • 1</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '2'"
                        >Major Repair • 2</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '3'"
                        >Moderate Repair • 3</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '4'"
                        >Minor Repair • 4</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '5'">Good part • 5</ng-container>
                      <ng-container *ngIf="!item.vpcs_severity">N/A</ng-container>
                    </p>

                    <p
                      class="fs fs__sm mb-2"
                      [class.no-print]="!showNotApplicableValues && !isValidCost(item.labour_cost)"
                    >
                      <strong>{{ 'condition_modal.labour_cost' | translate }}:</strong>
                      {{ isValidCost(item.labour_cost) ? 'SAR ' + item.labour_cost : 'N/A' }}
                    </p>
                    <p
                      class="fs fs__sm mb-2 uiui9"
                      [class.no-print]="!showNotApplicableValues && !isValidCost(item.part_cost)"
                    >
                      <strong class="MKM">{{ 'condition_modal.parts_cost' | translate }}:</strong>
                      {{ isValidCost(item.part_cost) ? 'SAR ' + item.part_cost : 'N/A' }}
                    </p>
                    <p
                      class="fs fs__sm mb-2"
                      [class.no-print]="!showNotApplicableValues && !isValidCost(item.repair_cost)"
                    >
                      <strong>{{ 'condition_modal.cost_of_repair' | translate }}:</strong>
                      {{ isValidCost(item.repair_cost) ? 'SAR ' + item.repair_cost : 'N/A' }}
                    </p>

                    <p
                      class="fs fs__sm"
                      [class.no-print]="
                        !showNotApplicableValues &&
                        showRatingConditionValue(item.description) === 'N/A'
                      "
                    >
                      <strong>{{ 'condition_modal.description' | translate }}:</strong>
                      <!-- {{ item.description || 'N/A' }} -->
                      {{ showRatingConditionValue(item.description) }}
                    </p>
                  </figcaption>
                </figure>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="pagebreak"></div>

  <section class="report__gallery mb-5">
    <div class="container">
      <div class="report__heading mb-4">
        <h2 class="fs fs__md-high text-capitalize">{{ 'nav_gallery' | translate }}</h2>
      </div>
      <div class="row mx-n2">
        <div class="col-sm-3 px-2" *ngFor="let item of galleryData">
          <p class="fs fs__base mb-2" [ngSwitch]="lang">
            <ng-container *ngSwitchCase="'en'">{{ item['gallery_name'] }}</ng-container>
            <ng-container *ngSwitchCase="'ar'">{{ item['gallery_name_arabic'] }}</ng-container>
          </p>
          <div class="report__galleryThumb mb-3">
            <img src="{{ item['image'] }}" width="100" height="100" />
          </div>
        </div>
      </div>
    </div>
  </section>

  <ng-container *ngIf="lang === 'en'">
    <section class="report__disclaimer mb-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="disclaimer">
              <h4 class="fs fs__md mb-3">Disclaimer</h4>

              <p class="fs fs__sm mb-2">
                Market Value - Estimated value may change with country , City , Condition , usage
                type etc.
              </p>
              <p class="fs fs__sm mb-2">
                Repair cost - Estimated Value will change from workshop to workshop and repair type.
              </p>
              <p class="fs fs__sm mb-2">
                Dealer Purchase Price - Estimated value will change from dealer to dealer and from
                time to time.
              </p>
              <p class="fs fs__sm mb-2">
                CV - Calculated Value is a ratio calculated by system of All good parts verses All
                defective parts which the vehicle contains, System incorporates in its calculation
                the severity of the defective part as well
              </p>
              <p class="fs fs__sm">
                PV - Perceived value of the vehicle from the selling and buying prospective under
                special conditions such as good vehicle but repainted etc. CV becomes the market
                value if PV is not available or if Numerical value of CV becomes equal or less than
                PV
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ng-container>

  <ng-container *ngIf="lang === 'ar'">
    <section class="report__disclaimer mb-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="disclaimer">
              <h4 class="fs fs__md mb-3">إخلاء المسؤولية</h4>

              <p class="fs fs__sm mb-2">
                القيمة السوقية: قد تختلف القيمة التقديرية حسب الدولة والمدينة والحالة ونوع
                الاستخدام.
              </p>
              <p class="fs fs__sm mb-2">
                تكلفة الإصلاح: القيمة التقديرية قد تختلف من ورشة إلى أخرى ومن نوع إصلاح لآخر.
              </p>
              <p class="fs fs__sm mb-2">
                سعر الشراء من التاجر: القيمة التقديرية قد تختلف من تاجر لآخر ومن وقت لآخر.
              </p>
              <p class="fs fs__sm mb-2">
                CV – القيمة المحسوبة: هي نسبة يتم حسابها بواسطة النظام بين جميع الأجزاء السليمة
                مقابل جميع الأجزاء التالفة التي تحتويها المركبة، ويأخذ النظام في حسابه أيضًا درجة
                خطورة الجزء التالف.
              </p>
              <p class="fs fs__sm">
                PV – القيمة المتصورة: وهي القيمة المتوقعة للمركبة من منظور البيع والشراء تحت ظروف
                خاصة مثل كون المركبة جيدة لكن معاد طلاءها، وتصبح قيمة CV هي القيمة السوقية إذا لم
                تتوفر قيمة PV أو إذا أصبحت القيمة الرقمية لـ CV مساوية أو أقل من PV.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ng-container>

  <div class="report__btnGrp no-print py-3">
    <button type="button" class="btn btn__primary w-100" (click)="print()">Print</button>
  </div>
</main>

<div class="d-none" *ngIf="!isVinInfo">
  <iframe src="/vam/information" frameborder="0"></iframe>
</div>
